// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"1242":"f8c34e00","2900":"0b661f96","7828":"bf835c4f","8780":"fe2e56a0"}[chunkId] + ".chunk.js";
};